import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class GenericRestService {
  baseUrl: string;

  constructor(protected http: HttpClient) {}

  public get(path: string, params?: HttpParams): Observable<any> {
    return this.http.get(this.buildRoute(path), { params }).pipe(catchError(e => this.handleError(e)));
  }

  public post(path: string, data: any): Observable<any> {
    return this.http.post(this.buildRoute(path), data).pipe(catchError(e => this.handleError(e)));
  }

  public delete(path: string): Observable<any> {
    return this.http.delete(this.buildRoute(path)).pipe(catchError(e => this.handleError(e)));
  }

  public patch(path: string, patch: any): Observable<any> {
    return this.http.patch(this.buildRoute(path), patch).pipe(catchError(e => this.handleError(e)));
  }

  protected handleError(e: any) {
    return throwError(e || 'Server error');
  }

  protected buildRoute(path: string): string {
    return this.applySubstitutions(this.baseUrl) + 'api/' + path;
  }

  private applySubstitutions(url: string) {
    const myUrl = url.replace(/{{HOSTNAME}}/gi, location.hostname);
    return myUrl;
  }
}
